(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningPathVersionOpenBadges", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/learningPaths/version/openBadges/learningPathVersionOpenBadgesView.html",
            controller: ["frameworkService", "learningPathVersionOpenBadgesResource", "messageService", "cropPictureService", "$stateParams", "$localStorage", "$translate", "$state", "$uibModal", "_", LearningPathVersionOpenBadgesCtrl],
            controllerAs: "vm"
        };
        function LearningPathVersionOpenBadgesCtrl(frameworkService, learningPathVersionOpenBadgesResource, messageService, cropPictureService, $stateParams, $localStorage, $translate, $state, $uibModal, _) {
            var vm = this;
            vm.showErrors = false;
            vm.loading = true;
            vm.modelValid = true;
            vm.enabledLocalizations = frameworkService.data.tenant.enabledLocalizations;
            vm.openBadgesEnabled = frameworkService.data.tenantFeatures.openBadges;
            if (!vm.openBadgesEnabled)
                $state.go("main.notFound");
            var lang = $translate.proposedLanguage() || $translate.use();
            lang = lang.replace("-", "_");
            vm.tinymceOptions = {
                resize: false,
                height: 300,
                plugins: "autoresize code wordcount",
                language: lang,
                convert_urls: 0
            };
            learningPathVersionOpenBadgesResource.get({ number: $stateParams.number, version: $stateParams.version }, function (data) {
                vm.model = data;
                vm.originalEnabledState = vm.model.openBadgesEnabled;
                vm.selectedLocalizationId = parseInt($localStorage.currentLocalizationId);
                vm.loading = false;
            }, function (error) {
                messageService.error(error);
            });
            vm.save = function () {
                vm.saving = true;
                if (vm.isFormValid()) {
                    learningPathVersionOpenBadgesResource.save({ number: $stateParams.number, version: $stateParams.version }, vm.model, function (data) {
                        //remove all the temp folders where image was saved
                        vm.model.openBadges.forEach(function (badge) {
                            if (badge.cropData && badge.cropData.tempFolderGuid)
                                cropPictureService.removeTempFolder(badge.cropData.tempFolderGuid);
                        });
                        vm.model = data;
                        vm.selectedLocalizationId = parseInt($localStorage.currentLocalizationId);
                        messageService.success("common.changesSaved");
                        vm.saving = false;
                        //We will create a button to do this. It will queue up missing badges to be created.
                        //if (vm.model.openBadgesEnabled && vm.originalEnabledState === false) {
                        //	//run an async call to create missing badges
                        //	learningPathVersionOpenBadgesResource.createMissingBadges({ number: $stateParams.number, version: $stateParams.version }, { value: vm.model.versionId }, function () {
                        //	}, function (error) {
                        //		messageService.error(error);
                        //	});
                        //}
                        vm.originalEnabledState = vm.model.openBadgesEnabled;
                    }, function (error) {
                        messageService.error(error);
                        vm.saving = false;
                    });
                }
                else {
                    vm.saving = false;
                    vm.showErrors = true;
                }
            };
            vm.changeLanguage = function (localizationId) {
                vm.selectedLocalizationId = localizationId;
            };
            vm.validate = function () {
                if (vm.model.openBadgesEnabled) {
                    if (_.find(vm.model.openBadges, function (item) { return !item.image || !item.criteria || !item.name || !item.description; })) {
                        vm.error = "learningPath.openBadges.formError";
                        vm.modelValid = false;
                        vm.showErrors = true;
                    }
                    else {
                        vm.clearError();
                    }
                }
                else {
                    vm.clearError();
                }
            };
            vm.clearError = function () {
                vm.error = null;
                vm.modelValid = true;
            };
            vm.isFormValid = function () {
                vm.validate();
                return vm.modelValid && vm.form.$valid;
            };
            vm.changeImage = function (badge) {
                var localizationId = badge.localizationId;
                var modalInstance = cropPictureService.changePicture(badge.cropData, {
                    //image restrictions
                    jcrop: {
                        bgColor: '#fff',
                        minSize: [90, 90],
                        maxWidth: 600,
                        maxHeight: 1024,
                        boxWidth: 400,
                        boxHeight: 400,
                        aspectRatio: 1 //image has to be square
                    }
                }, { supportedFiles: ".png", fileSize: "256KB" }); //must be png and no more than 245kb
                modalInstance.result.then(function (pictureData) {
                    //Crop the image so its shown properly on the page
                    if (pictureData.cropData && pictureData.cropData.fileUrl) {
                        vm.processingImage = true;
                        badge.cropData = pictureData.cropData;
                        var model = { number: vm.model.number, version: vm.model.version, cropData: pictureData.cropData, localizationId: localizationId };
                        learningPathVersionOpenBadgesResource.cropImage({ number: $stateParams.number, version: $stateParams.version }, model, function (data) {
                            //Set the crop info for the badge to be saved later
                            badge.cropDataJson = data.cropDataJson;
                            badge.cropData = JSON.parse(data.cropDataJson);
                            badge.image = data.fileUrl;
                            vm.processingImage = false;
                        }, function (error) {
                            messageService.error(error);
                            vm.saving = false;
                            vm.processingImage = false;
                        });
                    }
                }).catch(angular.noop);
            };
            vm.previewCriteria = function (badge) {
                var issuer = vm.model.issuer;
                $uibModal.open({
                    templateUrl: "app/learningPaths/version/openBadges/previewCriteriaModalView.html",
                    controller: function () {
                        var vm = this;
                        vm.badgeDetails = badge;
                        vm.badgeDetails.issuer = issuer;
                    },
                    controllerAs: "vm",
                    size: "lg"
                }).result.catch(angular.noop);
            };
        }
    });
}());
